import * as types from '../actions/types';

const initialState = {
    accessToken:'', 
    userId:'',
    loginresponse:{}
}

export default function loginReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.LOGIN_AUTH:
            return {
                ...state,
                loginresponse:action.payload,
                accessToken:action.payload.data.user.Token,
                userId:action.payload.data.user.admin_user_id,
                
            } 
        default:
            return state
    }
}
